"use strict";

import "../scss/style.scss";

import IntersectionObserverInview from "./IntersectionObserverInview.js";
import IntersectionObserverScroll from "./IntersectionObserverScroll.js";
import IntersectionObserverFix from "./IntersectionObserverFix.js";
import MicroModalWindow from "./MicroModalWindow.js";
import VanillaCounter from "./VanillaCounter";
// import VanillaFormBridge from "./VanillaFormBridge";
import VanillaSmoothScroll from "./VanillaSmoothScroll";
// import SplideFlowSlider from "./SplideFlowSlider";
import VanillaHeaderController from "./VanillaHeaderController";
import VanillaAccordion from "./VanillaAccordion";
import VanillaPageTab from "./VanillaPageTab";
import SplideFreeSlider from "./SplideFreeSlider";
import VanillaInputFilled from "./VanillaInputFilled";
import SplideFvSlider from "./SplideFvSlider";
import PhotoSwipeGallery from "./PhotoSwipeGallery";
import FireflyCanvas from "./FireflyCanvas";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new IntersectionObserverInview(".js-inview", "js-inview-acv");
    new IntersectionObserverScroll("#js-images", "is-active");
    new IntersectionObserverFix("#js-points", "#js-fix", "is-active");
    new MicroModalWindow();
    new VanillaCounter("#js-minus", "#js-plus", "#frm-people");
    // new VanillaFormBridge(
    //   "#js-fix-date",
    //   "#js-fix-people",
    //   "#frm-date",
    //   "#frm-people",
    // );
    new VanillaSmoothScroll(1000);
    // new SplideFlowSlider("#js-flow-splide");
    new VanillaHeaderController("#js-header");
    new VanillaAccordion(
      ".js-accordion-box",
      ".js-accordion-trigger",
      ".js-accordion-cnt",
    );
    new VanillaPageTab();
    new SplideFreeSlider("#js-imgs-splide");
    new SplideFreeSlider("#js-comments-splide");
    new SplideFreeSlider("#js-related-splide");
    new VanillaInputFilled(
      "#js-fix-date, #js-fix-people, #frm-name, #frm-date, #frm-mail, #frm-tel, #frm-cnt",
    );
    new SplideFvSlider("#js-fv-splide");
    new PhotoSwipeGallery("#js-photo-swipe1");
    new PhotoSwipeGallery("#js-photo-swipe2");
    new PhotoSwipeGallery("#js-photo-swipe3");
    new FireflyCanvas("#canvas");
  },
  false,
);
